import { PERFILES } from '@src/perfiles'
import AREAS from './areas'

const AREAS_PERFILES = {
  [AREAS.ARMERIA]: [
    PERFILES.Armeria,
    PERFILES.ARMERIA_LOC,
    PERFILES['ARMERIA_PASE DE LISTA'],
    PERFILES['ARMERIA_PERSONAL LOC'],
    PERFILES['ARMERIA_CATALOGOS E INVENTARIO ARMAS'],
    PERFILES['ARMERIA_CATALOGOS E INVENTARIO ACCESORIOS'],
  ],
  [AREAS.EQUIPAMIENTO]: [PERFILES.Equipamiento, PERFILES.EQUIPAMIENTO_ADMINISTRADOR],
  [AREAS.IFCSP]: [
    PERFILES.Profesionalización,
    PERFILES.IFCSP_RECLUTAMIENTO,
    PERFILES.IFCSP_ADMINISTRADOR,
    PERFILES.IFCSP_PROFESIONALIZACION,
  ],
  [AREAS.DESARROLLO_POLICIAL]: [
    PERFILES.DP_ADMINISTRADOR,
    PERFILES.DP_CUP,
    PERFILES.DP_CONVOCATORIAS_CONDECORACIONES,
    PERFILES.DP_EVALUACIONES,
  ],
  [AREAS.ENLACE_C3]: [
    PERFILES['Enlace C3'],
    PERFILES['ENLACE C3_ADMINISTRADOR'],
    PERFILES['ENLACE C3_CAPTURA DE RESULTADOS'],
    PERFILES['ENLACE C3_CAPTURA DE EXPEDIENTE'],
    PERFILES['ENLACE C3_CAPTURA DE RESULTADOS'],
  ],
  [AREAS.RECURSOS_HUMANOS]: [
    PERFILES['Recursos Humanos'],
    PERFILES.RH_ADMINISTRADOR,
    PERFILES['RH_TRAMITES ADMINISTRATIVOS'],
    PERFILES['RH_CAMBIO DE ESTATUS/ADSCRIPCION'],
    PERFILES['RH_REGISTRO DE PERSONAL'],
  ],
  [AREAS.REGISTRO_PERSONAL]: [
    PERFILES.REP_ADMINISTRADOR,
    PERFILES.REP_REGISTRO,
    PERFILES.REP_CREDENCIALIZACION,
    PERFILES['Personal / Site'],
    PERFILES.REP_BIOMETRIA,
  ],
  [AREAS.ENLACE_COMISARIA]: [
    PERFILES['COMISARIA_CAPTUREA'],
    PERFILES['COMISARIA_SUPERVISOR'],
    PERFILES['ADMINSITRADOR GENERAL'],
    PERFILES['USUARIO_ANALITICA'],
    PERFILES['ANALISTA_ANALITICA'],
  ],
}
export default AREAS_PERFILES
